/*
  封装的ajax请求接口
  方法： POST
  参数： params
  数据： body
*/

import sha256 from 'sha256'
import store from './store'
import qs from 'qs'
import { LS } from 'assets/js/storage'
import Vue from 'vue'
import { Message } from 'element-ui'
import axios from 'axios'
import VueCookies from 'vue-cookies'
import * as common from 'src/config/common-config'
Vue.use(VueCookies)
const api = new Vue()

// 请求地址前缀
export const path = process.env.NODE_ENV === 'production' ? '' : 'api'

// 获取xbbAccessToken
function getXbbAccessToken () {
  const lsToken = LS.get('xbbAccessToken')
  const ckToken = api.$cookies.get('xbbAccessToken')
  let xbbAccessToken = '321321321' // 开发环境默认值

  // 如果cookie中有值，以cookie中的为准，如果cookie中没有值，则获取LocalStorage中的值，如果都没有，则给一个默认值
  if (ckToken) {
    xbbAccessToken = ckToken
    LS.set('xbbAccessToken', xbbAccessToken)
  } else if (lsToken) {
    xbbAccessToken = lsToken
  }
  api.$cookies.remove('xbbAccessToken', '/')
  return xbbAccessToken
}

// 创建axios实例
const http = axios.create({
  // `method` 是创建请求时使用的方法
  method: 'post', // 默认是 post
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json, text/plain, */*'
  },
  withCredentials: true,
  data: {
    platform: 'web',
    frontDev: process.env.NODE_ENV === 'production' ? 0 : 1 // 本地测试时，此参数可略过登录验证
  }
})

// 添加请求拦截器
http.interceptors.request.use(
  config => {
    const params = utils.json(config.data.params)

    // 文件导出需设置额外属性
    if (config.url.indexOf('exportList/listAjax.do') > -1 || params.exportType) {
      config.responseType = 'arraybuffer'
      config.exportType = params.exportType
      // console.log('request', config)
    }

    // 标记response按照请求顺序返回
    if (config.data && params.isSync) {
      /*
        生成一个时间戳，绑定到url，一个存到到全局变量，另一个添加到请求配置中并随response返回
        然后拿response返回的时间戳与全局变量中的去比对，如果不一致，则添加一个为按请求顺序返回的标记
      */
      const date = (new Date()).getTime()
      window.stamps = window.stamps || {}
      window.stamps[config.url] = config[config.url] = date
    }

    // 将请求参数格式化为formdata
    config.data = qs.stringify(config.data)
    return config // 此处切记记得将请求参数return出去
  },
  error => {
    // 对请求错误做些什么
    Promise.reject(error)
  }
)

// 添加响应拦截器
http.interceptors.response.use(
  response => {
    let { data, config, headers } = response

    // 文件导出特殊处理
    if (config.exportType) {
      /*
        只有导出数据小于1000条时，该接口才会返回Excel文件；
        当数据大于1000条时，返回的是正常文本数据，因此需要将ArrayBuffer转为普通文本
      */
      const hasExcel = JSON.stringify(headers).indexOf('excel') > -1
      // console.log('headers', headers)
      if (hasExcel) {
        fileExport(response, config.exportType)
        return Promise.reject()
      } else {
        // 将 ArrayBuffer 转为 string, https://stackoverflow.com/questions/17191945/conversion-between-utf-8-arraybuffer-and-string
        const string = String.fromCharCode.apply(null, new Uint8Array(data))
        const decodedString = decodeURIComponent(escape(string))
        data = decodedString
      }
    }

    // 判断是否开启了，按照请求顺序返回
    const requestUrl = config.url
    if (config[requestUrl] && config[requestUrl] !== window.stamps[requestUrl]) {
      // 未按请求顺序返回，按异常处理
      return Promise.reject()
    }

    // 如果response.data 为JSON格式，则解析为Object
    if (typeof data === 'string') {
      data = utils.json(data)
    }
    // 只将response 中的 data 输出
    return data
  },
  error => {
    // 对响应错误做点什么
    return Promise.reject(error)
  }
)

// 文件导出处理
function fileExport ({ data }, exportType) {
  const fileNameType = common.moduleMap[exportType]
  const date = (new Date()).toISOString().slice(0, 10)
  const fileName = `${fileNameType.replace('信息', '')}信息${date}${exportType === 'workOrder' ? '.xlsx' : '.xls'}`
  const blob = new Blob([data])
  const elink = document.createElement('a')
  elink.download = fileName
  elink.style.display = 'none'
  elink.href = URL.createObjectURL(blob)
  document.body.appendChild(elink)
  elink.click()
  URL.revokeObjectURL(elink.href) // 释放URL 对象
  document.body.removeChild(elink)
}

export const post = function (url, body, cb, errorCb) {

  // 过滤特殊字符
  function CharacterFilter (str) {
    let newStr = ''
    for (let i = 0; i < str.length; i++) {
      const us = str.charCodeAt(i)
      if (!(us < 0x20 || us === 0x7F || us === 0x2028 || us === 0x2029)) {
        newStr += str.charAt(i)
      }
    }
    return newStr
  }

  // 格式化请求参数
  function formatParams (params) {
    const baseParams = {
      corpid: api.$cookies.get('corpid') || 1,
      // java的encode，decode方法与js的encode和decode方法有差异（空格分别会被替换为 “+”，“%20”），
      // 所以这里将 encode后的 “+”替换为 “%20”，而原本的“+”，经java的encode后会变为 “%2b”，所以 + 不会被误替换
      nowUserId: decodeURI((api.$cookies.get('userid') || '1').replace(/\+/g, '%20'))
    }

    let bodyString = JSON.stringify(Object.assign(baseParams, params))
    // 过滤特殊字符
    if (bodyString.length > 100) {
      bodyString = CharacterFilter(bodyString)
    }
    return bodyString
  }

  // 生成签名
  function createSign (bodyString) {
    const xbbAccessToken = getXbbAccessToken()
    return sha256(bodyString + xbbAccessToken)
  }
  const bodyString = formatParams(body)
  const specEnmus = store.getters.getSpecialEnmus // 获取特殊枚举类

  http({
    url: url.indexOf('http') > -1 ? url : path + url, // 根据条件判断是否需要拼接请求路径
    data: {
      params: bodyString,
      JSESSIONID: specEnmus.JSESSIONID,
      sign: createSign(bodyString)
    }
  }).then(data => {

    if (data.code === 1) {
      cb(data)
    } else {
      if (data.msg) {
        Message({
          type: 'error',
          message: data.msg,
          duration: 2000,
          onClose () {
            // 当登录信息验证失败时，跳转到登录页面
            if (data.code === 100012) {
              window.location = '/user/autoLogin.html'
            } else {
              // 当code为其他时，将code提交到vuex
              store.dispatch('setErrorCode', data.code)
            }
          }
        })
      }

      // 当服务端返回的code不为1时，触发errorCb回调函数
      errorCb && errorCb(data)
    }
  }).catch(error => {
    // 服务端异常或响应拦截器异常
    errorCb && errorCb(error)

    // 会有部分内部错误，没有error信息
    if (!error) return

    // 可以被监听到的异常信息，抛出给用户
    console.warn(error.message)
    const status = error && error.response && error.response.status
    switch (status) {
      case 400:
        error.message = '请求错误'
        break
      case 401:
        error.message = '未授权，请登录'
        break
      case 403:
        error.message = '拒绝访问'
        break
      case 404:
        error.message = `请求地址出错: ${error.config.url}`
        break
      case 408:
        error.message = '请求超时'
        break
      case 500:
        error.message = `服务器开小差了: ${error.config.url}`
        break
      case 501:
        error.message = '服务未实现'
        break
      case 502:
        error.message = `网关错误: ${error.config.url}`
        break
      case 503:
        error.message = '服务不可用'
        break
      case 504:
        error.message = `网关超时: ${error.config.url}`
        break
      case 505:
        error.message = 'HTTP版本不受支持'
        break
      default:
        error.message = `未知网络故障`
    }
    // 用户反馈较多，暂时不抛出错误信息给用户
    // Message({ message: error.message, type: 'error', duration: 5 * 1000 })
  })
}

// mock处理
export const mock = function (url, params, cb, errorCb) {
  if (process.env.MOCK) {
    api.$http.post('/mock' + url, params)
    .then((response) => {
      cb(response.body)
    })
  } else {
    post(url, params, cb, errorCb)
  }
}

export const _$cookies = api.$cookies



// WEBPACK FOOTER //
// ./src/api.js